/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import { isMobile } from "react-device-detect";
import axios from "axios";
import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import "react-confirm-alert/src/react-confirm-alert.css";
import "../../css/confirm.css";

class Event202304_uma_gamecode_show extends Component {
  state = {};
  componentDidMount = () => {
    const { loginId, history } = this.props;

    if (loginId === null || loginId === undefined || loginId === "") {
      history.push("/login");
    } else {
      this._getCode();
    }
  };
  componentWillUnmount = () => {};

  _onClose = () => {
    const { setEventIdx } = this.props;
    setEventIdx(0);
  };
  _getCode = async () => {
    const { loginId, pkg, apiUrl, history } = this.props;
    const orderCode = this.props.childProps.orderCode;
    const at = localStorage.getItem("at");

    if (loginId === null || loginId === undefined || loginId === "") {
    } else {
      const result = await axios
        .post(
          apiUrl + "/event_uma_gamecode_codelist",
          {
            params: {
              userid: loginId,
              pkg: pkg,
              orderCode: orderCode,
            },
          },
          {
            headers: {
              Authorization: "bearer " + at,
            },
          }
        )
        .catch((error) => {
          console.error(error.response.status);
          if (error.response.status === 403) {
            //console.log('refresh....token...')
            this._refreshToken();
          } else if (error.response.status === 400) {
            history.push("/login");
          }
        });

      if (result) {
        const intReturn = result.data[0].intReturn;
        const codeList = result.data[0].listData;
        if (intReturn === 0) {
          this.setState({
            codeList,
          });
        }
      }
    }
  };
  _refreshToken = async () => {
    const { gotoPage } = this.state;
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    const rt = localStorage.getItem("rt");

    if (rt === "" || rt === undefined || rt === null) {
      history.push("/login");
      return false;
    }

    const { data } = await axios.post(apiUrl + "/refreshToken", {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem("at", data[0].at);
      this._getOrderList();
    } else {
      this.setCookie("account", "");

      setLoginId("");
      setAuthId("");

      setTimeout(() => {
        history.push("/login");
      }, 500);
    }
  };
  _renderItem = () => {
    const { codeList } = this.state;
    const list = codeList.map((item) => {
      return (
        <li>
          <a style={{ cursor: "pointer" }}>{item.gameCode}</a>
          <a
            style={{ cursor: "pointer" }}
            onClick={() => this._copy(item.gameCode)}
            className="code_copy"
          >
            <i className="ico_copy"></i>시리얼 코드 복사하기
          </a>
        </li>
        // <tr key={item.orderCode}>
        //   <td>{item.orderCode}</td>
        //   <td>{item.goodCount}</td>
        //   <td>
        //     {item.gameCode}{" "}
        //     <span
        //       style={{ color: "#fff" }}
        //       onClick={() => this._copy(item.gameCode)}
        //     >
        //       copy
        //     </span>
        //   </td>
        // </tr>
      );
    });

    return list;
  };
  _copy = (gameCode) => {
    if (navigator.clipboard) {
      // (IE는 사용 못하고, 크롬은 66버전 이상일때 사용 가능합니다.)
      navigator.clipboard
        .writeText(gameCode)
        .then(() => {
          alert("클립보드에 복사되었습니다.");
        })
        .catch(() => {
          alert("복사를 다시 시도해주세요.");
        });
    } else {
      // 흐름 2.
      if (!document.queryCommandSupported("copy")) {
        return alert("복사하기가 지원되지 않는 브라우저입니다.");
      }

      // 흐름 3.
      const textarea = document.createElement("textarea");
      textarea.value = gameCode;
      textarea.style.top = 0;
      textarea.style.left = 0;
      textarea.style.position = "fixed";

      // 흐름 4.
      document.body.appendChild(textarea);
      // focus() -> 사파리 브라우저 서포팅
      textarea.focus();
      // select() -> 사용자가 입력한 내용을 영역을 설정할 때 필요
      textarea.select();
      // 흐름 5.
      document.execCommand("copy");
      // 흐름 6.
      document.body.removeChild(textarea);
      alert("클립보드에 복사되었습니다.");
    }
  };
  render() {
    const { imgUrl } = this.props;
    const { codeList, orderCode, showCode } = this.state;

    return (
      <Fragment>
        <ul>
          {codeList ? this._renderItem() : null}
          {/* <li>
            <a href="">w8wf434w44wk4wwe</a>
            <a href="" className="code_copy">
              <i className="ico_copy"></i>시리얼 코드 복사하기
            </a>
          </li>
          <li>
            <a href="">w9wf57w77wk7ewq</a>
            <a href="" className="code_copy">
              <i className="ico_copy"></i>시리얼 코드 복사하기
            </a>
          </li> */}
        </ul>
        {/* <div className="eventCon">
          <div>
            <table style={{ color: "#fff" }}>
              <tr>
                <td>주문번호</td>
                <td>수량</td>
                <td>시리얼 코드</td>
              </tr>
              {codeList ? this._renderItem() : null}
            </table>
          </div>
        </div> */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202304_uma_gamecode_show));
